import axios from 'axios';
import { updateField, getField } from 'vuex-map-fields';

const state = {
  user_data: {},
};

const getters = {
  getField,
};

const mutations = {
  updateField,

  // eslint-disable-next-line
  GET_USER: (state, payload) => {
    state.user_data = payload;
  },
};

const actions = {
  async getUser({ commit }, obj) {
    const response = await axios.get(
      `${process.env.API_ROOT}/user/${obj.userId}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );

    commit('GET_USER', response.data);
  },

  async editUser({ commit }, obj) {
    await axios.put(
      `${process.env.API_ROOT}/user/${obj.userId}`,
      {
        ...obj.data,
      },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async updatePassword({ commit }, obj) {
    await axios.put(
      `${process.env.API_ROOT}/user/password/${obj.userId}`,
      {
        ...obj.data,
      },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/users/index.js